module.exports = __webpack_public_path__ + "ab42554cd7e243266ef6e90a323cd0b3.pdf";